import { Unit, UnitBaseTypes } from "../../Units";

function Foot() {
  return (
    <>
      <Unit unit={UnitBaseTypes.foot} />
    </>
  );
}

export default Foot;
